/**
 * アンケート回答送信時のエラーが、株主番号などの入力形式エラー（HTTP 400）かどうかを判定する
 * @param {Object} err - submitSurveyAnswers が throw したエラー
 * @returns {boolean}
 */
export const isSurveyBackendValidationError = (err) =>
  err?.response?.status === 400;
